import { useRef } from 'react';

interface IRetryParams {
    retryAction: () => void;
    preRetryAction?: () => void;
    finalAction?: () => void;
    maxRetries?: number;
    firstRetryTimeout?: number;
    defaultRetryTimeout?: number;
}

const useRetryOnError = () => {
    let errorRetries = useRef(0);

    const handleRetryOnError = ({
        retryAction,
        preRetryAction,
        finalAction,
        maxRetries = 60,
        firstRetryTimeout = 2000,
        defaultRetryTimeout = 5000,
    }: IRetryParams) => {
        if (maxRetries >= errorRetries.current) {
            errorRetries.current = errorRetries.current + 1;
            const delay =
                errorRetries.current === 1
                    ? firstRetryTimeout
                    : defaultRetryTimeout;

            preRetryAction && preRetryAction();

            setTimeout(() => retryAction(), delay);
        } else {
            finalAction && finalAction();
        }
    };
    return handleRetryOnError;
};

export default useRetryOnError;
